import React from "react";

const TermsPolicy = () => {
  return (
    <>
      <div className="p-24">
        <div className="max-w-4xl mx-auto px-4 py-8 text-gray-800">
          <h1 className="text-3xl font-bold mb-6 text-center">
            Terms & Conditions
          </h1>

          <section className="space-y-6">
            <div>
              <h2 className="text-xl font-semibold mb-2">1. Introduction</h2>
              <p>
                These Terms & Conditions govern your use of our Visitor
                Management System ("VMS"). By using the system, you agree to
                comply with these terms.
              </p>
            </div>

            <div
              style={{
                marginBottom: "15px",
              }}
            >
              <h2 className="text-xl font-semibold mb-2">
                2. User Responsibilities
              </h2>
              <ul className="list-disc list-inside space-y-2">
                <li>
                  You must provide accurate and truthful information when
                  registering as a visitor.
                </li>
                <li>
                  You are responsible for complying with all security protocols
                  and policies set by the facility.
                </li>
                <li>
                  Unauthorized access or misuse of the system may lead to legal
                  action.
                </li>
              </ul>
            </div>

            <div
              style={{
                marginBottom: "15px",
              }}
            >
              <h2 className="text-xl font-semibold mb-2">
                3. System Access & Restrictions
              </h2>
              <ul className="list-disc list-inside space-y-2">
                <li>
                  The VMS is provided "as is" without warranties of any kind.
                </li>
                <li>
                  You may not attempt to hack, modify, or disrupt system
                  functionality.
                </li>
                <li>The system is intended for lawful use only.</li>
              </ul>
            </div>

            <div
              style={{
                marginBottom: "15px",
              }}
            >
              <h2 className="text-xl font-semibold mb-2">
                4. Data Collection & Privacy
              </h2>
              <ul className="list-disc list-inside space-y-2">
                <li>
                  Personal information collected through the VMS is subject to
                  our Privacy Policy.
                </li>
                <li>
                  By using the system, you consent to data collection and
                  processing for security purposes.
                </li>
              </ul>
            </div>

            <div
              style={{
                marginBottom: "15px",
              }}
            >
              <h2 className="text-xl font-semibold mb-2">
                5. Limitation of Liability
              </h2>
              <ul className="list-disc list-inside space-y-2">
                <li>
                  The Company is not responsible for any loss, damage, or
                  unauthorized access resulting from system use.
                </li>
                <li>
                  The Company reserves the right to suspend or terminate access
                  if misuse is detected.
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">6. Amendments</h2>
              <p>
                We reserve the right to update these terms at any time. Users
                will be notified of significant changes.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">7. Contact Us</h2>
              <p className="terms-paragraph">
                For inquiries regarding these Terms & Conditions, contact us at:{" "}
                <a
                  href="mailto:contact@genmindz.net"
                  className="text-blue-600 underline"
                >
                  contact@genmindz.net
                </a>
              </p>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default TermsPolicy;
